import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

var Config = require('../../../config');

class ModalUnits extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
		    show: false,
		    group:"",
		    process_name:"",
		    place:"",
		    units:[],
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(id, group, rh, group_rh, process_name, status, hf_id) {
		this.props.waiting.handleShow("Cargando...");
		var health = hf_id;
		fetch(Config.default.apiGateway.URL+'units/storage_details?blood_component_id='+id+
				'&health_facilities_id='+health+
				'&group='+group+'&rh='+rh+'&status='+status,{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({ 
					show:true,
					group: group_rh,
					process_name: process_name,
					place:sessionStorage.getItem("health_facilities_name"),
					units:response,
				});
			}
		})

	}


	render(){
		const { t } = this.props;
		return(
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Unidades</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row form-group">
		        		<div className="col-xs-12" style={{textAlign:"center"}}>
		        			<h3 style={{color:"red"}}>{this.state.group}</h3>
		        			<h4>{this.state.place}</h4>
		        			<h5>{this.state.process_name}</h5>
		        		</div>
		        		<div className="col-xs-12">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Fecha Donación</th>
										<th>Caducidad</th>
										
										<th>Unidad</th>
										<th>N. Comp</th>
										<th>Volumen</th>
										<th>Fenotipos</th>
										<th>Subgrupo</th>
										<th>Disponibilidad (días)</th>
										<th>Estatus</th>
									</tr>
								</thead>
								<tbody>
									{this.state.units.map((u, i)=>{
										return <tr key={i}>
											<td>{u.donation_date === undefined || u.donation_date === null ? '' : moment(u.donation_date).format('DD/MM/YYYY')}</td>
											<td>{u.caducidad === null || u.caducidad === undefined ? '' : moment(u.caducidad).format('DD/MM/YYYY')}</td>
										
											<td>{u.unit_number}</td>
											<td>{u.component_number}</td>
											<td>{u.volume}</td>
											<td>
												<label>
												{u.phenotype.map((f, j)=>{
													return f.phenotype1+f.result+', '
												})}
												</label>
											</td>
											<td>{u.lectina}</td>
											<td>{u.disponibles}</td>
											<td>{u.donation_status}</td>
										</tr>
									})}
								</tbody>
							</Table>
						</div>
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalUnits) 